import React, {useEffect, useState} from 'react';
import {Modal as ModalComponent} from 'presentation/components/Modal';
import {Button, Checkbox, FormControlLabel, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {useTermsOfAgreement} from 'presentation/hooks';
import {ModalProps} from './types';

const {title, subtitle, description1, description2, description3, description4, description5} =
	translations['pt-br'].privateFlow.refund.receiptRegistrationPage.sendingFiles.modal.terms;

const {keep, readAndAgree} = translations['pt-br'].commons;
export const UploadTermsModal = ({
	open,
	setOpen,
	termName,
	fileInputRef,
	isOpenedByDrandAndDrop,
}: ModalProps) => {
	const [checked, setChecked] = useState(false);
	const {setTermCookie} = useTermsOfAgreement();
	const shouldOpenFileInputAutomatically = !open && checked && !isOpenedByDrandAndDrop;

	function handleCheckTerms() {
		if (checked) {
			setTermCookie(termName);
			setOpen(false);
		}
	}

	useEffect(() => {
		if (fileInputRef.current && shouldOpenFileInputAutomatically) {
			fileInputRef.current.click();
		}
	}, [open, checked]);

	function handleToggle() {
		setChecked(prev => !prev);
	}

	function handleOnClose() {
		setOpen(prev => !prev);
		setChecked(false);
	}

	return (
		<ModalComponent.Root open={open} onClose={handleOnClose} customMaxWidth={448}>
			<ModalComponent.Header title={title} onClose={handleOnClose} />

			<ModalComponent.Content>
				<Typography variant="h6">{subtitle}</Typography>
				<Typography variant="body1" marginTop={2}>
					{description1}
				</Typography>
				<Typography variant="body1" marginTop={2}>
					{description2}
				</Typography>
				<Typography variant="body1">{description3}</Typography>
				<Typography variant="body1">{description4}</Typography>
				<Typography variant="body1">{description5}</Typography>
			</ModalComponent.Content>

			<ModalComponent.Footer>
				<Stack spacing={1} flex={1}>
					<FormControlLabel
						sx={{maxWidth: '140px'}}
						control={<Checkbox onChange={handleToggle} />}
						label={readAndAgree}
					/>
					<Button
						disabled={!checked}
						fullWidth
						variant="contained"
						onClick={handleCheckTerms}>
						{keep}
					</Button>
				</Stack>
			</ModalComponent.Footer>
		</ModalComponent.Root>
	);
};
